import React from 'react';
import { objectKeys } from '../../utils/object-keys';
export type IRefs = { [key in string]: React.RefObject<HTMLDivElement> };

/**
 * Method is detecting which element is currently on screen
 *
 * @function useElementOnScreen
 * @param `Object<IRefs>`
 *
 * `refs` is the object of refs with corresponding names as keys
 * `offset` is by default 0, but you can overwrite in case you have some fixed elements or similar
 */
export function useElementOnScreen({
    refs,
    offset = 0,
}: {
    refs: IRefs;
    offset: number;
}): { currentElementName: string } {
    const [currentElementName, setCurrentElementName] = React.useState('');

    React.useEffect(() => {
        const refKeys = objectKeys(refs);
        function listener() {
            refKeys.forEach((refName) => {
                const ref = refs[refName];
                if (!ref.current) return;

                const { top, bottom } = ref.current.getBoundingClientRect();

                if (top <= offset && bottom > offset) {
                    setCurrentElementName(refName);
                }
            });
        }
        window.document.addEventListener('scroll', listener);
        return () => {
            window.document.removeEventListener('scroll', listener);
        };
    }, [refs, offset, currentElementName]);

    return { currentElementName };
}
